import {Component} from 'substance'

import DialogMessageComponent from './DialogMessageComponent'
import DialogComponent from './DialogComponent'
import {Event} from '../../../lib/constants/Event'

class DialogPlaceholderComponent extends Component {

    constructor(...args) {
        super(...args)

        // Queued modals waiting to be displayed
        this.queue = []

        const actionHandlers = {}
        actionHandlers[Event.DIALOG_CLOSE] = () => {
            this.hideDialog()
        }
        this.handleActions(actionHandlers)
    }

    getInitialState() {
        return {
            open: false
        }
    }

    didMount() {
        this.context.api.setModalReference(this)
    }

    /**
     * Render modal dialog placeholder
     */
    render($$) {
        const el = $$('div').ref('placeholder')

        if (this.state.open) {
            el.append(
                $$(
                    DialogComponent,
                    {
                        content: this.state.contentComponent,
                        contentProps: Object.assign({}, this.state.props, this.context),
                        options: this.state.options
                    }
                )
            )
        }

        return el
    }

    /**
     * Open a modal dialog, or queues it if another modal is always open
     *
     * @param {Component} contentComponent The component passed in by the user, Should be instance of a Substance Component
     * @param {object} props An object passed by user that is later reached by this.props in the contentComponent
     * @param {object} options Options passed to the DialogComponent
     */
    showDialog(contentComponent, props, options) {
        if (!this.state.open) {
            this.extendState({
                open: true,
                contentComponent: contentComponent,
                props: props,
                options: options
            })
        }
        else {
            this.queue.push({
                contentComponent: contentComponent,
                props: props,
                options: options
            })
        }
    }

    /**
     * Open a message dialog, displaying a list of messages
     *
     * @param {string[]} messages An array of message structures
     * @param {object} props An object passed by user that is later reached by this.props in the contentComponent
     * @param {object} options Options passed to the DialogComponent
     */
    showMessageDialog(messages, props, options) {
        props.messages = {
            error: [],
            warning: [],
            info: [],
            title: []
        }

        for(var n = 0; n < messages.length; n++) {
            switch(messages[n].type) {
                case 'error':
                    props.messages.error.push(messages[n])
                    break
                case 'warning':
                    props.messages.warning.push(messages[n])
                    break
                case 'title':
                    props.messages.title.push(messages[n])
                    break
                default:
                    props.messages.info.push(messages[n])
            }
        }
        if (!this.state.open) {
            this.extendState({
                open: true,
                contentComponent: DialogMessageComponent,
                props: props,
                options: options
            })
        }
        else {
            this.queue.push({
                contentComponent: null,
                props: props,
                options: options
            })
        }

    }

    hideDialog() {
        const api = this.context.api
        if (api.editorSession) {
            api.editorSession.setSelection(
                api.editorSession.getSelection()
            )
        }

        this.setState({
            open: false
        })

        if (this.queue.length) {
            const next = this.queue.shift()
            this.showDialog(next.contentComponent, next.props, next.options)
        }
    }
}

export {DialogPlaceholderComponent}
